import { io } from 'socket.io-client';
import ApiService from './ApiService';
import { useRouter } from "vue-router";
import axios from 'axios';

class HeyvaOnlineApiService {
  socket: any;
  constructor() {
    // 
  }

  login(phone:any,password:any) {
    return axios.put(process.env.VUE_APP_BASE_URL+'/user/page/',{'email':phone, 'password':password})
  }

  setupSocketConnection(join:any,roomName:any) {
    const router = useRouter()
        if(!localStorage.getItem('credits'))
        {
            router.push({name: 'sign-in-signals'})
        }
        else
        {
            this.socket = io(process.env.VUE_APP_SOCKET_ENDPOINT);
            this.socket.emit(join, { username: localStorage.getItem('users'), token: ApiService.token, room: roomName});
            this.socket.on('message', (data: any) => {
              outputMessage(data,join);
            });
            this.socket.emit('my message', 'Hello there from Vue.');
            
            setTimeout(() => {
              this.socket.disconnect();
              //localStorage.removeItem('credits');
            }, 86400000); 
        }
  }

  disconnect() {
    console.log("-----------1-----------")
    this.socket.disconnect();
    localStorage.removeItem('credits');
    window.location.reload()
  }

  uforex2() {
    return axios.put(process.env.VUE_APP_BASE_URL+'/user/uforex/',{'email':localStorage.getItem('users')})
  }

//   uforex(){
    
//         axios.put('https://api.xaifin.com/user/uforex',{'email':localStorage.getItem('users')}).then((res)=>{
//             if (res.status==200) {
//                 localStorage.setItem('credits',res.data.user.credits)
//                 localStorage.setItem('users',phone.value)
//                 router.push({'name':'online-signals'})
//             }
//         }).catch((error)=>{                    
//             Swal.fire({
//                   text: error.response.data.mess,
//                   icon: "error"
//                 });
//         })
    
// }

  
}

function outputMessage(data: any,join:any) {
  if (join=='joinRoom1') {
    const div4 = document.createElement('div');
    div4.className = 'mt-1 p-1 rounded bg-secendary text-black fw-semibold mw-lg-400px text-start';
    div4.setAttribute("style", "text-align: left; direction:ltr;");
    const p = document.createElement('p');
    p.classList.add('meta');
    p.innerText = "";
    p.setAttribute("style", "padding-top: 5px");
    const para = document.createElement('p');
    para.classList.add('text');
    const paraz = data.text;
    para.innerText = paraz;  
    div4.appendChild(para);
    const container = document.querySelector(".chat1");
    if (container) {
      container.insertBefore(div4, container.firstChild);
    }
    // let div5: any;
    // div5 = 0;
    // div5 = document.querySelector(".chat2")?.scrollHeight;
    // document.querySelector(".chat2")?.scrollTo(0, div5);
  }
    else if (join=='joinRoom2') {
      const div4 = document.createElement('div');
    div4.className = 'mt-1 p-1 rounded bg-secendary text-black fw-semibold mw-lg-400px text-start';
    div4.setAttribute("style", "text-align: left; direction:ltr;");
    const p = document.createElement('p');
    p.classList.add('meta');
    p.innerText = "";
    p.setAttribute("style", "padding-top: 5px");
    const para = document.createElement('p');
    para.classList.add('text');
    const paraz = data.text;
    para.innerText = paraz;  
    div4.appendChild(para);
    const container = document.querySelector(".chat2");
    if (container) {
      container.insertBefore(div4, container.firstChild);
    }
    // let div5: any;
    // div5 = 0;
    // div5 = document.querySelector(".chat1")?.scrollHeight;
    // document.querySelector(".chat2")?.scrollTo(0, div5);
    }
  }

export default new HeyvaOnlineApiService();